import { startSSE, stopSSE } from './sse';

export async function ensureRealtime(userId) {
  console.log('🚀 [Realtime] Démarrage SSE pour userId:', userId);
  await startSSE(userId);
}

export function disconnectRealtime() {
  console.log('🔌 [Realtime] Déconnexion SSE');
  stopSSE();
}
